// extracted by mini-css-extract-plugin
export default {"container":"ThemeSelector_container__ad+1a","root":"ThemeSelector_root__onTiR"};